import type { DivisionListItem } from "~pages/Divisions/DivisionListPage/types/divisionListItem.ts";
import type { DivisionResources, DivisionResponse } from "~types/division.ts";
import type { Response } from "~types/response.ts";
import { transformListResponse } from "~utils/transformListResponse.ts";

export const transformDivisionsResponse = (response: DivisionResponse, conferenceId?: string) => {
  const conferenceName = response?.includes?.resources?.conferences?.[conferenceId ?? ""]?.nameLocal ?? "";
  const data = (response?.data || []).map((item) => ({
    ...item,
    conference: conferenceName,
  }));
  const listResponse: Response<DivisionListItem, DivisionResources> = {
    ...response,
    data,
  };

  return {
    ...transformListResponse(listResponse),
    conferenceName,
  };
};
